export const statNoAccessTitle = 'Stats';

export const statNoAccessFeatures = [
  'Compare new issue volume, deal counts and spreads across time',
  'Instantly view or download published stats in clean XLS formats',
  'Save time searching with filters by headline, region and time period',
];

export const statNoAccessDescription = 'Quickly analyze market performance with daily, weekly, monthly and annual stats created by industry leading analysts with years of reporting experience.';

export const statImageCaption = 'Explore recently published reports or focus on a specific category with the Stats sidebar.';
